import { IUserProfileData } from './types';

const actions = {
  USER_PROFILE_REQUEST: 'USER_PROFILE_REQUEST',
  USER_PROFILE_SUCCESS: 'USER_PROFILE_SUCCESS',
  USER_PROFILE_ERROR: 'USER_PROFILE_ERROR',

  userProfileRequest: () => ({
    type: actions.USER_PROFILE_REQUEST,
  }),

  userProfileSuccess: (data: IUserProfileData) => ({
    type: actions.USER_PROFILE_SUCCESS,
    payload: data,
  }),

  userProfileError: () => ({
    type: actions.USER_PROFILE_ERROR,
  }),
};

export default actions;
